import MuiTableCell from '@material-ui/core/TableCell';
import React from 'react';
import styled from 'styled-components';
import { BaseTableRow, TableColumn } from './types';

export const StyledTableCell = styled(MuiTableCell)<{ $isCompact?: boolean }>`
  height: 2rem;
  padding: ${({ $isCompact }) =>
    $isCompact ? '0.125rem 0.5rem' : '0.125rem 1rem'};
  white-space: pre-wrap;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayeee};

  &:first-of-type {
    padding-left: 1.5rem;
  }

  &.MuiTableCell-paddingNone {
    padding: 0;

    /* we still apply left padding for the first column, but it's smaller */
    &:first-of-type {
      padding-left: 1rem;
    }
  }
`;

function getCellContents<RowEntity extends BaseTableRow>(
  column: TableColumn<RowEntity>,
  row: RowEntity,
): React.ReactNode {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {typeof column.contents === 'function'
        ? column.contents(row)
        : row[column.contents]}
    </>
  );
}

interface TableCellProps<RowEntity extends BaseTableRow> {
  col: TableColumn<RowEntity>;
  isCompact?: boolean;
  row: RowEntity;
}

export function TableCell<RowEntity extends BaseTableRow>({
  col,
  isCompact,
  row,
}: TableCellProps<RowEntity>) {
  return (
    <StyledTableCell
      $isCompact={isCompact}
      align={col.align}
      width={col.width}
      padding={col.padding}
    >
      {getCellContents<RowEntity>(col, row)}
    </StyledTableCell>
  );
}
